import { memo } from 'react';
import { Link } from 'react-router-dom'

import '../assets/styles/components/find-agent-block.scss';

const FindAgentBlock = () => <div className="find-agent-block">
  <div className="container">
    <div className="left-block">
      <div className="title">
        Find an insurance professional near you
      </div>
      <Link to="/find-an-agent" className="action-btn-link">
        <button className='action-btn button-gradient'>
          Find an Agent
        </button>
      </Link>
    </div>
    <div className="right-block">
      <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-agent-block.svg`} alt="find-agent" />
    </div>
  </div>
</div>

export default memo(FindAgentBlock);
